import React from "react";
import { useQuery } from "@tanstack/react-query";
import { http } from "@/lib/api";
import { isPreviewHost } from "@/lib/env";
import { Warning } from "@phosphor-icons/react";

/**
 * Shows a coloured strip at the top of the page when the connected backend
 * is NOT production. Hidden completely in production. Helps prevent the
 * "oh god I just edited prod data" class of mistakes.
 */
export default function EnvBanner() {
  const previewSurface = isPreviewHost();
  const { data } = useQuery({
    queryKey: ["health"],
    queryFn: () => http.get("/health").then((r) => r.data),
    refetchInterval: 60000,
    retry: false,
    enabled: previewSurface,
  });
  // On a real production domain, never show the banner regardless of APP_ENV.
  if (!previewSurface) return null;
  const env = data?.app_env || "development";
  if (env === "production") return null;
  const meta = {
    development: { cls: "bg-amber-500", label: "Development" },
    staging:     { cls: "bg-purple-500", label: "Staging" },
  }[env] || { cls: "bg-slate-700", label: env };
  return (
    <div
      data-testid="env-banner"
      className={`${meta.cls} text-white text-[11px] font-heading uppercase tracking-wider font-semibold py-1 px-3 flex items-center justify-center gap-2`}
    >
      <Warning size={11} weight="fill" />
      {meta.label} environment · DB <span className="font-mono-data ml-0.5">{data?.db_name || "?"}</span>
    </div>
  );
}
